import { Directive, Input, ViewContainerRef, TemplateRef, OnInit } from '@angular/core';
import { UserPermissions } from '@shared-libs/enums';
import { UserManager } from '@app/modules/shared/managers/user.manager';

@Directive({
	selector: '[ifUserHasPermissions]',
})
export class UserPermissionDirective implements OnInit {
	@Input() public ifUserHasPermissions: Array<UserPermissions>;

	constructor(
		private readonly templateRef: TemplateRef<any>,
		private readonly viewContainer: ViewContainerRef,
		private readonly userManager: UserManager
	) {}

	public ngOnInit(): void {
		this.userManager.getUserPermissionsSubject().subscribe(() => {
			this.checkPermissions(this.ifUserHasPermissions);
		});
	}

	private checkPermissions(requiredPermissions: Array<UserPermissions>): void {
		if (this.userManager.hasAllPermissions(requiredPermissions)) {
			if (this.viewContainer.length <= 0) {
				this.viewContainer.createEmbeddedView(this.templateRef);
			}
		} else {
			this.viewContainer.clear();
		}
	}
}
